import Main from './Main'
import Level from './Level'
import Privilege from './Privilege'
import Transaction from './Transaction'
import TierBenefit from './TierBenefit'
import NewMyReward from './NewMyReward'
import StampCard from './StampCard'
import Expiredialog1 from './Expiredialog1'
import Expiredialog from './Expiredialog'
import EnglishMunMun from './EnglishMunMun'
import CUSTOMMain from './C/Main'
import LMGLevel from './C/Level'
import LMGPrivilege from './C/Privilege'
import CUSTOMTransaction from './C/Transaction'
import CUSTOMTierBenefit from './C/TierBenefit'
import CUSTOMNewMyReward from './C/NewMyReward'
import LMGStampCard from './C/StampCard'
import LMGExpiredialog1 from './C/Expiredialog1'
import LMGExpiredialog from './C/Expiredialog'
import LMGEnglishMunMun from './C/EnglishMunMun'
import StampRXTradex from './StampRXTradex'

export default {
  Main,
  Level,
  Privilege,
  Transaction,
  TierBenefit,
  NewMyReward,
  StampCard,
  Expiredialog1,
  Expiredialog,
  EnglishMunMun,
  CUSTOMMain,
  LMGLevel,
  LMGPrivilege,
  CUSTOMTransaction,
  CUSTOMTierBenefit,
  CUSTOMNewMyReward,
  LMGStampCard,
  LMGExpiredialog1,
  LMGExpiredialog,
  LMGEnglishMunMun,
  StampRXTradex
}



// WEBPACK FOOTER //
// ./src/components/Card/index.js